<template>
    <div class="locale-changer">
        <div v-if="$root.$i18n.locale == 'en'">
            <button @click="changeLocale('de')">
                <img :src="imageSrc('de')" width="40">
            </button>
        </div>
        <div v-else>
            <button @click="changeLocale('en')">
                <img :src="imageSrc('gb')" width="40">
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'locale-changer',

    data () {
        return { }
    },

    methods: {
        changeLocale: function(locale) {
            this.$root.$i18n.locale = locale;
            this.$root.$emit('changedLocale');
        },

        imageSrc: function(locale) {
            return require('../assets/icons/' + locale + '.svg');
        }
    }
}
</script>

<style>

.locale-changer div {
    position: absolute;
    left: 33px;
    bottom: 51px;
}

.locale-changer button {
    position: absolute;
    opacity: 1;
    cursor: pointer;
    background-color: transparent;
    border: none;
    outline:none;
    font-family: 'Regular';
    font-size: 20px;
    color: #131313;
    z-index: 9999;
}

@media only screen and (max-device-width: 1366px) {
    .locale-changer div {
        left: 33px;
        bottom: 40px;
    }
}
</style>